const CheckIcon = props => (
  <svg
    width={14}
    height={11}
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.956543 6.00725L2.40582 4.12319L6.17393 7.31159L12.2609 0.5L14 2.0942L6.31886 10.5L0.956543 6.00725Z"
      fill="white"
    />
  </svg>
)

export default CheckIcon
